import {Component, effect, inject, model, ModelSignal, Signal} from '@angular/core';
import {DELETE_ACTION, ITableAction, TableControlComponent, TableControlModule,} from 'frontier/browserkit';
import {changes, EControlActions, IControlDataChanged, INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {filter, tap} from 'rxjs/operators';
import {Unsubscribable} from 'rxjs';
import {ProcessOverviewStore} from '../../../service/process-overview.store';
import AppControlGuids from '../../../../../../api/ControlGuids';
import {ICart, IProcessState} from "../../../service/state.interface";

@Component({
  selector: 'app-item-correction-list',
  templateUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrls: [
    '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss'
  ],
  standalone: true,
  imports: [TableControlModule],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}},
    {provide: TableControlComponent, useExisting: ItemCorrectionComponent},
  ],
})
export class ItemCorrectionComponent extends TableControlComponent {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);

  selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;
  selectedProcess: Signal<IProcessState> = this._processOverviewService.selectedProcess;

  override GUID: string = AppControlGuids.TItemCorrectionList;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([DELETE_ACTION]);

  constructor() {
    super();
    effect((): void => {
      const selectedCart: ICart = this.selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj,
          typename: 'cart',
        });
      }
    }, {allowSignalWrites: true});

    this.subs.add(
      this.controlStore.controlDataChanged$.pipe(
        filter((evt: IControlDataChanged): boolean => {
          return new Map([
            [AppControlGuids.TCartItemsList, new Set([
              ...changes,
              EControlActions.partlyCancel,
              EControlActions.cancelItemValue,
              EControlActions.invoice,
            ])],
            [AppControlGuids.TInvoiceList, new Set([
              ...changes,
              EControlActions.cancel,
              EControlActions.credit,
              EControlActions.rollback,
              EControlActions.uncollectible,
              EControlActions.payed,
              EControlActions.reroll,
            ])],
          ]).get(evt.GUID)?.has(evt.changeType);
        }),
        tap((): Unsubscribable => this.changeAndFetchInstance())).subscribe(),
    );
  }
}
